import React, { useEffect, useState } from "react";
import "./BankingPartners.css";
import callApi from "../../../../utility/apiCaller";
// import { hardcoded } from "./BankingPartnersHardcodedList";

const BankingPartners = () => {
  const [lenders, setLenders] = useState([]);

  useEffect(() => {
    const preferredOrder = [
      "Aditya Birla Finance Limited",
      "L&T",
      "Tata Capital",
      "Poonawalla",
      "UnityBank",
      "Hero Fincorp",
      "Kissht",
      "KreditBee",
      "Branch",
      "Incred",
      "DMI",
      "Muthoot",
    ];

    const fetchLenders = async () => {
      const [bucket1, bucket2] = await Promise.all([
        callApi("v1/lender/active-bucket1-lenders", "post", {}, "loan"),
        callApi("v1/lender/active-bucket2-lenders", "post", {}, "loan"),
      ]);

      const combined =
        bucket1?.status === "Success" && bucket2?.status === "Success"
          ? [...bucket1.data.lenderList, ...bucket2.data.lenderList]
          : [];

      // Add hardcoded lender manually

      const hardcodedLender = [
        {
          name: "Aditya Birla Finance Limited",
          logo_image_url: "/assets/bank_img/abc.png",
        },
        {
          name: "Hero Fincorp",
          logo_image_url: "/assets/bank_img/herofincorplogo.png",
        },
        {
          name: "L&T",
          logo_image_url: "/assets/bank_img/bank_lnt.png",
        },
        {
          name: "Muthoot",
          logo_image_url: "/assets/bank_img/muthoot.png",
        },
        {
          name: "Tata Capital",
          logo_image_url: "/assets/bank_img/tcp.png",
        },
        {
          name: "DMI",
          logo_image_url: "/assets/bank_img/DMI Size 2.png",
        },
      ];

      const merged = [...hardcodedLender, ...combined];

      const ordered = [
        ...preferredOrder
          .map((name) => merged.find((l) => l.name === name))
          .filter(Boolean),
        ...merged.filter((l) => !preferredOrder.includes(l.name)),
      ];

      setLenders(ordered);
    };

    fetchLenders();
  }, []);

  return (
    <div className="plv16-bp-section">
      <div className="plv16-bp-card">
        <div className="plv16-bp-title">RBI registered partners</div>
        <div className="plv16-bp-logos" role="list">
          {lenders.map((lender) => (
            <div
              key={lender.name || lender.logo_image_url}
              className="plv16-bp-logo-wrap"
              role="listitem"
            >
              <img
                src={lender.banking_partners || lender.logo_image_url}
                alt={lender.name ? `${lender.name} logo` : "Lender logo"}
                className="plv16-bp-logo"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
      <div className="plv16-bp-note">Offer subject to final verification</div>
    </div>
  );
};

export default BankingPartners;
